<div class="auth-layout-container">
  <!-- Toggle para modo oscuro -->
  <button
    class="theme-toggle"
    (click)="toggleDarkMode()"
    placement="left"
    ngbTooltip="Cambiar tema"
    [openDelay]="300"
    [autoClose]="true"
    triggers="hover"
  >
    <i class="bi" [ngClass]="isDarkMode ? 'bi-sun-fill' : 'bi-moon-fill'"></i>
  </button>

  <!-- Overlay con gradiente -->
  <div class="auth-overlay"></div>

  <!-- Área del formulario (40%) -->
  <div class="auth-form-container">
    <div class="auth-form-content">
      <div class="brand-logo">
        @if (isDarkMode) {
        <img src="/assets/logo-b.png" alt="Logo" />
        } @else {
        <img src="/assets/logo.png" alt="Logo" />
        }
      </div>

      <!-- Router outlet para las páginas de autenticación -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
